import React, { useState } from 'react';

const usePaginationHook = () => {
  const [currentPage, setCurrentPage] = useState(0);
  const [perPage, setPerPage] = useState(10);
  const [sortBy, setSortBy] = useState({
    id: 'id',
    desc: true,
  });

  const [searchTerm, setSearchTerm] = useState('');

  return {
    currentPage,
    setCurrentPage,
    perPage,
    setPerPage,
    sortBy,
    setSortBy,
    searchTerm,
    setSearchTerm,
  };
};

export default usePaginationHook;
